'use client';

import { BlogCategory } from '@prisma/client';

interface CategoryBadgeProps {
  category: BlogCategory;
  size?: 'sm' | 'md' | 'lg';
}

const CATEGORY_CONFIG = {
  EATS: {
    label: '🍴 Eats',
    colors: {
      bg: '#FFF5EB',
      border: '#F8C8A0',
      text: '#D97706',
    },
    icon: '🍴',
  },
  DIARY: {
    label: '📔 Diary',
    colors: {
      bg: '#F3EFFA',
      border: '#C9B6E4',
      text: '#7C3AED',
    },
    icon: '📔',
  },
  PLAY: {
    label: '🎮 Play',
    colors: {
      bg: '#E0F2FE',
      border: '#A8D8E6',
      text: '#0284C7',
    },
    icon: '🎮',
  },
  TEACH: {
    label: '📚 Teach',
    colors: {
      bg: '#EDE9FE',
      border: '#B4A0E5',
      text: '#7C3AED',
    },
    icon: '📚',
  },
};

export function CategoryBadge({ category, size = 'md' }: CategoryBadgeProps) {
  const config = CATEGORY_CONFIG[category];
  
  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-3 py-1',
    lg: 'text-base px-4 py-1.5',
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold ${sizeClasses[size]}`}
      style={{
        backgroundColor: config.colors.bg,
        border: `2px solid ${config.colors.border}`,
        color: config.colors.text,
      }}
    >
      <span>{config.icon}</span>
      <span>{config.label.replace(/^.+ /, '')}</span>
    </span>
  );
}

export function getCategoryColors(category: BlogCategory) {
  return CATEGORY_CONFIG[category].colors;
}

export function getCategoryIcon(category: BlogCategory) {
  return CATEGORY_CONFIG[category].icon;
}

export function getCategoryLabel(category: BlogCategory) {
  return CATEGORY_CONFIG[category].label;
}

